





























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {}
})
export default class CardModalDaftarObat extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() daftarObat!: [];

  get headers() {
    return [
      { text: "Detail", value: "data-table-expand", sortable: false },
      { text: "Tanggal Transaksi", value: "tgl" },
      { text: "No Transaksi", value: "no_transaksi" },
      { text: "Depo", value: "depo" }
    ];
  }
  get headersDetail() {
    return [
      { text: "No", value: "index" },
      { text: "Nama Obat", value: "obat" },
      { text: "Jumlah", value: "jumlah" },
      { text: "Dosis", value: "dosis" },
      { text: "Frekuensi", value: "frekuensi" },
      { text: "Keterangan", value: "keterangan" }
    ];
  }

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  @Watch("value")
  changeValue(val) {}

  close() {
    this.dialog = false;
  }

  formatDate(date) {
    return date ? moment(date, "YYYY-MM-DD").format("DD-MM-YYYY") : "";
  }
}
